import apiClient from '../client.js'

async function createPriority(scope, payload) {
  return apiClient.post(`/${scope}/tickets/priorities`, payload)
}

async function updatePriority(scope, id, patch) {
  return apiClient.patch(`/${scope}/tickets/priorities/${id}`, patch)
}

async function deletePriority(scope, id) {
  return apiClient.delete(`/${scope}/tickets/priorities/${id}`)
}

class PriorityService {
  create = {
    /**
     * Create a priority under the settings scope.
     *
     * @param {string} scope - Settings API URL prefix (`ticket-account` or `ticket-group/:id`).
     * @param {object} payload
     * @returns {Promise<import('axios').AxiosResponse>}
     */
    async priority(scope, payload) {
      return createPriority(scope, payload)
    },
  }

  update = {
    /**
     * Update one priority under the settings scope.
     *
     * @param {string} scope - Settings API URL prefix (`ticket-account` or `ticket-group/:id`).
     * @param {string} id
     * @param {object} patch
     * @returns {Promise<import('axios').AxiosResponse>}
     */
    async priority(scope, id, patch) {
      return updatePriority(scope, id, patch)
    },
  }

  delete = {
    /**
     * Delete one priority under the settings scope.
     *
     * @param {string} scope - Settings API URL prefix (`ticket-account` or `ticket-group/:id`).
     * @param {string} id
     * @returns {Promise<import('axios').AxiosResponse>}
     */
    async priority(scope, id) {
      return deletePriority(scope, id)
    },
  }
}

export default new PriorityService()
